//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapActions, mapState} from "vuex";
import SimpleActionButton from "@/components/shared/simple-action-button";

export default {
  name: "SelectStoreDialog",

  components: {
    SimpleActionButton,
  },

  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    selectRegister: {
      type: Boolean,
      default: false,
    }
  },

  data() {
    return {};
  },

  async mounted(){
    if(this.$auth.loggedIn && !this.selectRegister && !this.stores?.length) {
      await this.fetchStores();
    }
  },

  computed: {
    ...mapState("common/stores", ["stores"]),
    ...mapState("registers", ["registers"]),
    items(){
      return this.selectRegister ? this.registers : this.stores
    },
    itemTypeName(){
      return this.selectRegister ? 'register' : 'store'
    }
  },

  methods: {
    ...mapActions('common/stores',['fetchStores']),
    close() {
      this.$emit("close", false);
    },
    async onItemSelected(item) {
        if(this.selectRegister) {
            this.$emit("onRegisterSelected", item);
        }
        else {
            this.$emit("onStoreSelected", item);
        }
    },
  },
};
